// ** React Imports
import React, { memo, useRef } from 'react';

// ** Components Imports
import AiSpeakerChat from './components/ai-speaker-chat';
import { AiSeqCopilotUserChat } from '../../type';
import { capitalizeFirstLetter } from '../../../../../leads/helpers/helper';

/**
 * @prop chatConversation - It will store the id, speaker and message of copilot chat.
 * @prop firstName - it will show firstName of user.
 * @prop lastName - it will show lastName of user.
 * @returns React Component
 */

const AiCopilotUserChatCard: React.FC<{
  chatConversation: AiSeqCopilotUserChat[];
  firstName: string;
  lastName: string;
}> = ({ chatConversation = [], firstName = '', lastName = '' }) => {
  const chatContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="ai-copilot-user-chat-card-container" ref={chatContainerRef}>
      {chatConversation?.map((item, index) => {
        const isSameSpeaker =
          index !== 0 && item.speaker === chatConversation?.[index - 1].speaker;
        return (
          <AiSpeakerChat
            key={item?.id}
            message={item?.message}
            speaker={item?.speaker}
            firstName={
              capitalizeFirstLetter(firstName ?? '')
            }
            lastName={capitalizeFirstLetter(lastName ?? '')}
            isSameSpeaker={isSameSpeaker}
            isNewMessage={index === chatConversation?.length - 1}
          />
        );
      })}
    </div>
  );
};

export default memo(AiCopilotUserChatCard);
